import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const systems = [
    { name: 'Pythagorean', path: '/pythagorean' },
    { name: 'Chaldean', path: '/chaldean' },
    { name: 'Gematria', path: '/gematria' },
    { name: 'Western', path: '/western' },
    { name: 'Vedic', path: '/vedic' },
    { name: 'BaZi', path: '/bazi' },
    { name: 'Agrippa', path: '/agrippa' },
    { name: 'Enochian', path: '/enochian' },
    { name: 'Sepharial', path: '/sepharial' },
    { name: 'Eliphas Levi', path: '/eliphas-levi' },
    { name: 'Liber 777', path: '/liber777' },
    { name: 'Abramelin', path: '/abramelin' },
    { name: 'Plato', path: '/plato' },
  ];

  return (
    <footer className="mt-auto border-t border-alchemical bg-white/90 sacred-geometry-bg">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="font-mystical text-xl mb-4">
              <span className="number-mystical">CALCULATIONS</span>
            </h3>
            <p className="font-philosophical text-sm text-gray-600">
              Ancient wisdom through modern calculation
            </p>
            <div className="mt-4">
              <p className="font-ancient text-xs text-gray-500">
                "Mathematics is the language with which God wrote the universe"
              </p>
              <p className="font-ancient text-xs text-gray-400 mt-1">
                — Galileo
              </p>
            </div>
          </div>

          {/* Systems */}
          <div className="md:col-span-2">
            <h4 className="font-mystical text-sm mb-4 text-gray-700">
              <span className="glyph-mercury mr-1"></span>
              Systems & Calculations
            </h4>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              {systems.map((system) => (
                <Link
                  key={system.path}
                  to={system.path}
                  className="font-philosophical text-sm text-gray-600 hover:text-yellow-600 transition-colors"
                >
                  {system.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-mystical text-sm mb-4 text-gray-700">
              <span className="glyph-saturn mr-1"></span>
              Information
            </h4>
            <div className="space-y-2">
              <Link
                to="/faq"
                className="block font-philosophical text-sm text-gray-600 hover:text-yellow-600 transition-colors"
              >
                FAQ
              </Link>
              <Link
                to="/terms"
                className="block font-philosophical text-sm text-gray-600 hover:text-yellow-600 transition-colors"
              >
                Terms
              </Link>
              <a
                href="https://github.com/hew/numerology-apl"
                target="_blank"
                rel="noopener noreferrer"
                className="block font-philosophical text-sm text-gray-600 hover:text-yellow-600 transition-colors"
              >
                GitHub
              </a>
              <a
                href="https://x.com/tahini"
                target="_blank"
                rel="noopener noreferrer"
                className="block font-philosophical text-sm text-gray-600 hover:text-yellow-600 transition-colors"
              >
                Contact on X
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="divider-mystical my-8"></div>

        {/* Copyright */}
        <div className="text-center">
          <p className="font-philosophical text-xs text-gray-500">
            © {currentYear} Calculations 
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;